import { createContext, HTMLAttributes, useContext } from "react";

import { cn, cv, type VariantProps } from "../utils";

const defaultVariant = "vertical";

const NcStaticListContext = createContext<{
  variant: "vertical" | "horizontal";
}>({ variant: defaultVariant });

const ncStaticListVariants = cv("", {
  variants: {
    variant: {
      vertical: "",
      horizontal: "",
    },
  },
  defaultVariants: {
    variant: "vertical",
  },
});

interface NcStaticListProps
  extends HTMLAttributes<HTMLUListElement>,
    VariantProps<typeof ncStaticListVariants> {}

const NcStaticList = ({ className, variant, ...props }: NcStaticListProps) => {
  return (
    <NcStaticListContext.Provider value={{ variant: variant ?? defaultVariant }}>
      <ul
        data-nc="NcStaticList"
        className={cn(ncStaticListVariants({ variant }), className)}
        {...props}
      />
    </NcStaticListContext.Provider>
  );
};

const ncStaticListItemVariants = cv("", {
  variants: {
    variant: {
      vertical: "border-ui p-3 not-last-of-type:border-b",
      horizontal: "inline not-last:after:content-[',_']",
    },
  },
  defaultVariants: {
    variant: "vertical",
  },
});

type NcStaticListItemProps = HTMLAttributes<HTMLLIElement>;

const Item = ({ className, ...props }: NcStaticListItemProps) => {
  const { variant } = useContext(NcStaticListContext);
  return (
    <li
      data-nc="NcStaticList.Item"
      className={cn(ncStaticListItemVariants({ variant }), className)}
      {...props}
    />
  );
};

NcStaticList.Item = Item;

export { NcStaticList };
